import React from 'react';
import { toast } from "../../../utils/toast";

function Sidebar({ stats, settings, onToggleSetting }) {
  return (
    <div className="sidebar">
      {/* 통계 */}
      <div className="sidebar-section">
        <h3 className="sidebar-title">통계</h3>
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-label">전체 채팅</div>
            <div className="stat-value">{stats.totalChats}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">미확인</div>
            <div className="stat-value stat-warning">{stats.unreadChats}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">답변 완료</div>
            <div className="stat-value stat-success">{stats.repliedChats}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">답변률</div>
            <div className="stat-value">{stats.replyRate}%</div>
          </div>
        </div>
      </div>

      {/* 설정 */}
      <div className="sidebar-section">
        <h3 className="sidebar-title">설정</h3>
        <div className="settings-list">
          <div className="setting-item">
            <div className="setting-info">
              <div className="setting-label">자동 답변</div>
              <div className="setting-description">
                새 메시지에 AI가 자동으로 답변을 생성합니다
              </div>
            </div>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={settings.autoReply}
                onChange={() => onToggleSetting('autoReply')}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>

          <div className="setting-item">
            <div className="setting-info">
              <div className="setting-label">알림</div>
              <div className="setting-description">
                새 메시지가 도착하면 알림을 받습니다
              </div>
            </div>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={settings.notification}
                onChange={() => onToggleSetting('notification')}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>
        </div>
      </div>

      {/* 빠른 작업 */}
      <div className="sidebar-section">
        <h3 className="sidebar-title">빠른 작업</h3>
        <div className="quick-actions">
          <button className="btn btn-outline" onClick={() => window.location.reload()}>
            새로고침
          </button>
          <button className="btn btn-outline" onClick={() => toast('준비 중입니다')}>
            채팅 내역 다운로드
          </button>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
